import { Site } from '@debbie/common/dist/index.js';
import { useSelector } from 'react-redux';
const UpdateTypeLabel = (props) => {
    const site = useSelector((state) => state.site);
    const lang = useSelector((state) => state.lang);
    return ((Site.Client === site
        ? // @ts-ignore
            lang.updateTypesClient[props.updateTypeId] ||
                lang.updateTypes[props.updateTypeId]
        : lang.updateTypes[props.updateTypeId]) || props.label);
};
export default UpdateTypeLabel;
//# sourceMappingURL=UpdateTypeLabel.js.map